module.exports = __webpack_public_path__ + "static/img/fishGame4.89bec12.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/fishGame4.png
// module id = 0y7o
// module chunks = 3